import React, { Component } from "react";
import PropTypes from "prop-types";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { withLDConsumer } from "ldclient-react"
import env from "../../utils/env";
// import LayoutReader from '@bit/fabfitfun.shared.global.layout-reader';

import Header from "../Header/Header";
import SharedBoxHeader from "../SharedBoxHeader/SharedBoxHeader";
import AddOnsPanel from "../Panels/AddOnsPanel/AddOnsPanel";
import BoostPanel from "../Panels/BoostPanel/BoostPanel";
import CustomizePanel from "../Panels/CustomizePanel/CustomizePanel";
import ExplorePanel from "../Panels/ExplorePanel/ExplorePanel";
import CustomizationCTA from "../Panels/CustomizationCTA/CustomizationCTA";

import {
  checkAuth,
  getBoxData,
  getUserData,
  saveRevealState,
  getSkipInfo,
  getUserFirstName,
  getUserAvatar,
  getUserBoxReview,
} from "../../utils/data";

import boxStates from "../../utils/boxStates";

import { setBoxData } from "../../modules/box";
import { setLayoutData } from "../../modules/layout";
import ShareMyBox from "../ShareMyBox/ShareMyBox";
import { setUserData, setTestUserData, setSkipInfo } from "../../modules/user";

// Mock Data
// import boxSelf from "../../utils/mockServices/boxSelf";
// import boxSelfClosedAOC from "../../utils/mockServices/boxSelfClosedAOC";
// import boxSelfClosedAO from "../../utils/mockServices/boxSelfClosedAO";
// import boxSelfClosedC from "../../utils/mockServices/boxSelfClosedC";
// import boxSelfNoChoices from "../../utils/mockServices/boxSelfNoChoices";
// import boxSelfNoChoicesNoItems from "../../utils/mockServices/boxSelfNoChoicesNoItems";
// import boxSelfCustomizeClosed from "../../utils/mockServices/boxSelfCustomizeClosed";
// import boxSelfSharedAuthorized from "../../utils/mockServices/sharedBoxNoAddons";
// import boxSelfSharedProspect from "../../utils/mockServices/sharedBoxProspect";

// import userExpired from "../../utils/mockServices/userExpired";
// import userUpgraded from "../../utils/mockServices/userUpgraded";

// const boxMockId = 8;
// const userMockId = 1;

// const boxMocks = [
//   boxSelf,
//   boxSelfClosedAOC,
//   boxSelfClosedAO,
//   boxSelfClosedC,
//   boxSelfNoChoices,
//   boxSelfNoChoicesNoItems,
//   boxSelfCustomizeClosed,
//   boxSelfSharedAuthorized,
//   boxSelfSharedProspect
// ];

// const userMocks = [userExpired, userUpgraded];

// const boxSelfMockData = boxMocks[boxMockId];
// const userSelfMockDate = userMocks[userMockId];

class Home extends Component {
  state = {
    sysdata: {
      isMobile: this.props.isMobile,
      getBoxData: getBoxData,
      getUserData: getUserData,
      saveRevealState: saveRevealState,
      isProspect: true
    }
  };

  componentDidMount() {
    let isSharedBox = this.isSharedBox();
    let boxId = this.getBoxId(isSharedBox);
    Promise.all([getUserData(), getBoxData(isSharedBox, boxId), getUserFirstName(boxId), getUserAvatar(boxId), getUserBoxReview()])
      .then(values => {
        this.props.setUserData(values[0]);
        this.props.setBoxData(values[1]);
        // this.props.setUserData(userSelfMockDate); // Mockdata
        // this.props.setBoxData(boxSelfMockData); // Mockdata
        this.setState({
          sysdata: {
            ...this.state.sysdata,
            boxData: values[1],
            userData: this.props.userData,
            // boxData: boxSelfMockData, // Mockdata
            // userData: userSelfMockDate, // Mockdata
            revealCallback: this.revealCallback,
            isSharedBox: isSharedBox, // set this here to not even show the sharedBox view if no data was returned
            firstName: values[2],
            avatarUrl: values[3],
            isProspect: values[0].success === false ? true : false,
            boxReview: values[4],
          }
        });
      })
      .catch(err => {
        // TODO Show Sorry page or redirect
        console.error("error getting required data ¯\\_(ツ)_/¯", err);
      });

    getSkipInfo().then(res => this.props.setSkipInfo(res));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isMobile !== this.props.isMobile) {
      this.setState({
        sysdata: {
          ...this.state.sysdata,
          isMobile: this.props.isMobile
        }
      });
    }
  }

  showExplorePanel = boxData => {
    const validStates = [
      boxStates.DELIVERED,
      boxStates.PROB_DELIVERED,
      boxStates.SHIPPED,
      boxStates.PAST_SEASON
    ];

    if (
      boxData.currentBox &&
      validStates.indexOf(boxData.currentBox.boxStatus) > -1
    ) {
      return true;
    }
    return false;
  };

  showCustomizePanel = boxData => {
    const inValidStates = [
      boxStates.DELIVERED,
      boxStates.PROB_DELIVERED,
      boxStates.SHIPPED,
      boxStates.PAST_SEASON
    ];

    if (
      !boxData.currentBox ||
      inValidStates.indexOf(boxData.currentBox.boxStatus) < 0
    ) {
      return true;
    }

    return false;
  };

  isSharedBox = () => {
    let isSharedBox = false;
    let urlParams = new URLSearchParams(window.location.search);
    let { sharedBoxParam } = env;
    if(urlParams.has(sharedBoxParam) && urlParams.get(sharedBoxParam) !== '')
      isSharedBox = true;
    return isSharedBox;
  };

  getBoxId = (isSharedBox) => {
    if(isSharedBox)
      return new URLSearchParams(window.location.search).get(env.sharedBoxParam);
    return null;
  }

  revealCallback = res => {
    getBoxData().then(boxData => {
      this.setState({
        sysdata: {
          ...this.state.sysdata,
          boxData: boxData,
          // boxData: boxSelfMockData, // Mockdata
        }
      });
    });
  };

  render() {
    const { sysdata } = this.state;
    const { boxData, isSharedBox, isMobile, isProspect, firstName, boxReview } = sysdata;
    const { hasSkipped, skipEligible } = this.props.userData;
    // const shareMyBoxFlag = this.props.flags ? this.props.flags.growthEnableShareMyBox : false;
    const flags = this.props.flags ? this.props.flags : null;
    const showGrowthReactivatePopUp = this.props.flags ? this.props.flags.growthReactivatePopUp : false;
    const { growthShareMyBoxShared, growthEnableShareMyBox, aceBoostShowMybox, rateMyBoxLinkOnMyBox } = flags;
    const userFirstName = firstName ? firstName.firstName + "'s" : "your friend's";
    // Blank page when data is not returned
    if (!boxData || !!boxData.code) {
      return (
        <div className="pos-r h-100-vh">
          <img
            className="pos-a page-loading-image"
            src="https://static.fabfitfun.com/magazine/wp-content/themes/fabfitfun/assets/img/fff-circle-loading.png"
          />
        </div>
      );
    }

    const isExploreShown = this.showExplorePanel(boxData);
    const isCustomizeShown = this.showCustomizePanel(boxData);
    return (
      <React.Fragment>
        {isSharedBox ? <SharedBoxHeader sysdata={sysdata}/> : 
          <Header
            sysdata={sysdata}
            hasSkipped={hasSkipped}
            skipEligible={skipEligible}
            showGrowthReactivatePopUp={showGrowthReactivatePopUp}
            boxReview={boxReview}
            rateMyBoxLinkOnMyBoxFlag={rateMyBoxLinkOnMyBox}
          />
        }
        {growthEnableShareMyBox && !isSharedBox ? <ShareMyBox title="Share my Add-Ons and Customizations" sysdata={sysdata} /> : null}
        {growthShareMyBoxShared && isSharedBox ? <ShareMyBox title={`Share ${userFirstName} Add-Ons and Customizations`} sysdata={sysdata} /> : null}
        {isExploreShown && !isSharedBox && <ExplorePanel sysdata={sysdata} />}
        <AddOnsPanel sysdata={sysdata} showGrowthReactivatePopUp={showGrowthReactivatePopUp} />
        {isSharedBox && isProspect && <CustomizationCTA isMobile={isMobile}/>}
        {isCustomizeShown && !isSharedBox && !isProspect && <div className="hor-rule mar-h-40" />}
        {isCustomizeShown && <CustomizePanel sysdata={sysdata} showGrowthReactivatePopUp={showGrowthReactivatePopUp} />}
        {aceBoostShowMybox && (
          <React.Fragment>
            <div className="hor-rule mar-h-40" />
            <BoostPanel sysdata={sysdata} />
          </React.Fragment>
        )}
      </React.Fragment>
    );
  }
}

const mS = state => ({
  boxData: state.box.data,
  layout: state.layout,
  userData: state.user,
  isMobile: state.view.isMobile
});

const mD = dispatch =>
  bindActionCreators(
    {
      setBoxData,
      setLayoutData,
      setUserData,
      setTestUserData,
      setSkipInfo
    },
    dispatch
  );

export default connect(
  mS,
  mD
)(withLDConsumer()(Home));

Home.propTypes = {
  setBoxData: PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./src/Components/MyBoxPage/MyBoxPage.js